import { Injectable } from '@angular/core';
import { DeliveryNotesService as DSService } from 'api/services';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ServiceEndpoints } from '@app/shared/models/service-model/service-endpoints';
import { AppConfig } from '@app/app.config';

@Injectable({
    providedIn: 'root',
})
export class DeliveryNotesService {
    apiUrl: string;
    constructor(
        private deliveryNotesService: DSService,
        private httpClient: HttpClient,
        public appConfig: AppConfig
    ) {
        this.apiUrl = this.appConfig.apiUrl;
    }

    /**
     * Uploads the given delivery note to an existing delivery note bundle.
     * @param organizationSiteKey
     * @param deliveryNoteBundleKey
     * @param deliveryNoteFileName
     * @param uploadFile
     */
    uploadDeliveryNote(
        organizationSiteKey: string,
        deliveryNoteFileName: string,
        uploadFile_Base64: string,
        deliveryNoteBundleKey: string = '',
        orderNumber: string,
        announcedDate: number,
        number: string,
        originalConsignor: string,
        originalConsignorGln: string,
        referenceNumber: string,
        showDateAnnouncedTime: boolean = false
    ): Observable<any> {
        const data = {
            fileName: deliveryNoteFileName,
            deliveryNote: uploadFile_Base64,
            number: number,
            orderNumber: orderNumber,
            dateAnnounced: announcedDate,
            originalConsignorGln: originalConsignorGln,
            originalConsignor: originalConsignor,
            showDateAnnouncedTime: showDateAnnouncedTime,
            properties: {
                referenceNumber: referenceNumber,
            },
        };
        if (deliveryNoteBundleKey) {
            const url =
                this.apiUrl +
                ServiceEndpoints.uploadDeliveryNoteBundled
                    .replace(':organizationSiteKey', organizationSiteKey)
                    .replace(':deliveryNoteBundleKey', deliveryNoteBundleKey);

            return this.httpClient.post(url, data, {
                reportProgress: true,
                observe: 'events',
                responseType: 'json',
            });
        } else {
            const url =
                this.apiUrl +
                ServiceEndpoints.uploadDeliveryNote.replace(
                    ':organizationSiteKey',
                    organizationSiteKey
                );
            return this.httpClient.post(url, data, {
                reportProgress: true,
                observe: 'events',
                responseType: 'json',
            });
        }
    }
}
